
<div class="location-related">
  <loading [isLoading]="locationRelatedService.isLoadingList"></loading>
  <!-- buscador -->
   <!-- *ngIf="!includeRoute" -->
  <div class="searchBar-flex" >
    <div class="searchBar" id="searchLocationInput">
      <mat-form-field class="width-input">
        <input
          #filterGlobal
          [(ngModel)]="globalFinder"
          matInput
          placeholder="Buscar por identificador"
          spellcheck="false"
          type="text"
          (input)="filter(filterGlobal.value)"
        />
      </mat-form-field>
    </div>
    <div class="btnSearch-container" (click)="filter(filterGlobal.value)">
      <img class="btnSearchIcon" src="/assets/img/icon_search.png" width="25px">
    </div>
  </div>

  <!-- <div class="button-list" *ngIf="includeRoute">
    <div mat-button class="btn-refresh" (click)="refreshRelatedList()" matTooltip="Reestablecer">
      <mat-icon>refresh</mat-icon>
    </div>
    <div mat-button class="btn-update" (click)="updateRelatedList()" matTooltip="Actualizar">
      <mat-icon>save_alt</mat-icon>
    </div>
  </div> -->

  <!-- cartas -->  <!--  cdkDropList (cdkDropListDropped)="drop($event)" -->
   <div class="cards-container">
    <div class="row location-related-data" *ngFor="let item of shownLocationRelatedList" (click)="clickService(item)" cdkDrag >

      <div class="row general-data d-flex align-items-center service-header" [class]="'header-'+item.statusByPriority">
        <div class="col-1 d-flex align-items-center service-header-font mr-0 pr-0">
          <label class="header_panel titlePanel"> <mat-icon>calendar_view_day</mat-icon></label>
        </div>
        <div class="col-9 d-flex align-items-center service-header-font ml-0 pl-0">
          <label class="header_panel titlePanel"> {{  item.identifierChild | slice:0:30}}</label>
        </div>
        <!-- pin de color -->
        <!-- <div class="col-2 d-flex align-items-center service-header-font">
          <label class="header_panel titlePanel"> 
            <span class="locationRelatedIcon" [style]="'background-color: '+ item.pinColorHex +';' "></span>
          </label>
        </div> -->
      </div>
  
      <div class="service-body" [class]="'background-'+item.statusByPriority">
        <div class="row general-data d-flex align-items-center">
          <p > {{ item.description | slice:0:100}}</p>
        </div>
        <div class="row general-data bold d-flex align-items-center">
          <p > {{ item.direction | slice:0:100}}</p>
        </div>
      </div>
  
    </div>
  
    <div class="row location-related-data" *ngIf="shownLocationRelatedList.length <= 0">
      <div >
        <h3>{{ this.locationRelatedListResponse}}</h3>
      </div>
    </div>
   </div>
  
</div>